import React from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
// import Header from "./header/Header";
import { MutantNavbar } from "./header/MutantNavbar";
import { withRouter } from "react-router-dom";
import HeaderMobile from "./header/HeaderMobile";
import AsideLeft from "./aside/AsideLeft";
import ScrollTop from "../../app/partials/layout/ScrollTop";
import HTMLClassService from "./HTMLClassService";
import LayoutConfig from "./LayoutConfig";
import LayoutInitializer from "./LayoutInitializer";
import KtContent from "./KtContent";
import QuickPanel from "../../app/partials/layout/QuickPanel";
import "./assets/Base.scss";
import { MenuConfig } from "./MenuConfig";

const htmlClassService = new HTMLClassService();

function Layout({
	children,
	// asideDisplay,
	history,
	selfLayout,
	layoutConfig
}) {
	const asideDisplay = false;
	htmlClassService.setConfig(layoutConfig);
	window.scrollTo(0, 0);

	return selfLayout !== "blank" ? (
		<LayoutInitializer
			styles={[]}
			menuConfig={MenuConfig}
			layoutConfig={LayoutConfig}
			htmlClassService={htmlClassService}
		>
			{/* <!-- begin:: Header Mobile --> */}
			<div
				style={{
					maxHeight: "30px",
				}}
			>
				<MutantNavbar menuItems={MenuConfig()} history={history} />
			</div>
			<HeaderMobile />
			{/* <!-- end:: Header Mobile --> */}

			<div className="kt-grid kt-grid--hor kt-grid--root">
				{/* <!-- begin::Body --> */}
				<div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
					{/* <!-- begin:: Aside Left --> */}
					{asideDisplay && (
						<>
							<AsideLeft />
						</>
					)}
					{/* <!-- end:: Aside Left --> */}
					{/* <!-- end:: Header --> */}
					<div
						style={{
							width: "100%",
							marginTop: "90px"
						}}
					>
						<KtContent>{children}</KtContent>
					</div>
					{/*<!-- end:: Content Body -->*/}
					{/* </div> */}
					{/* <!-- end:: Content --> */}
					{/* </div> */}
				</div>
				{/* <!-- end:: Body --> */}
			</div>
			<QuickPanel />
			<ScrollTop />
		</LayoutInitializer>
	) : (
		// BLANK LAYOUT
		<div className=""
			style={{
				marginTop: "130px"
			}}
		
		>
			<KtContent>{children}</KtContent>
		</div>
	);
}

const mapStateToProps = ({ builder: { layoutConfig } }) => ({
	layoutConfig,
	selfLayout: objectPath.get(layoutConfig, "self.layout"),
	asideDisplay: objectPath.get(layoutConfig, "aside.self.display"),
	subheaderDisplay: objectPath.get(layoutConfig, "subheader.display")
});

export default withRouter(connect(mapStateToProps)(Layout));
